import { translateError } from "../../lib/errors";
import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabase";
import { useAuth } from "../../lib/auth";
import { AuthAlert, AuthShell, Field } from "../../components/auth/AuthShell";
import { Loader, Spinner } from "../../components/ui/Loader";

export const ResetPassword = () => {
  const navigate = useNavigate();
  const { loading, user } = useAuth();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (loading) {
    return <Loader />;
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) {
        setError(translateError(error));
      } else {
        navigate("/dashboard", { replace: true });
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthShell
      title="Новий пароль"
      subtitle="Встановіть новий пароль для вашого акаунта"
    >
      <form onSubmit={handleSubmit} className="mt-7 flex flex-col gap-4">
        <Field
          label="Новий пароль"
          type="password"
          placeholder="Мінімум 7 символів"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
          minLength={7}
          required
        />
        {error && <AuthAlert kind="error" message={error} />}
        <button
          type="submit"
          disabled={submitting}
          className="btn-brand mt-2 w-full justify-center disabled:opacity-70"
        >
          {submitting ? (
            <>
              <Spinner className="h-4 w-4" />
              Зачекайте…
            </>
          ) : (
            "Зберегти пароль"
          )}
        </button>
      </form>
    </AuthShell>
  );
};
